import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message,Image } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import "./index.scss"
import { getRequest } from '../../utils/request';

const buttonLayout = {
  wrapperCol: {
    offset: 10,
    span: 16
  }
}

const App: React.FC = () => {

  const [form] = Form.useForm()
  const [messageApi, contextHolder] = message.useMessage();
  const [count, setCount] = useState(60)
  const [liked, setLiked] = useState(true)

  // 成功提示
  const success = (text: string) => {
    messageApi.open({
      type: 'success',
      content: text,
    });
  };

  // router Hooks
  const navigate = useNavigate()

  const submitData = async () => {
    const data = form.getFieldsValue()
    console.log(data)
    let res = await getRequest("/api/note/verCode", data)
    if (res.code == 200) {
      sessionStorage.setItem("token", res.data.token)
      sessionStorage.setItem("isLogin", "1")
      localStorage.setItem("userId", res.data.userId)
	  const roleName=res.data.roleNames;
	  if(roleName&&roleName.length>0){
	  	localStorage.setItem("roleName", roleName.join(","))
	  }else{
		  localStorage.setItem("roleName", "");
	  }
      console.log(res)
      success("登录成功")
      navigate("/home")
    }
  };
  const getCode = async () => {
    const data = form.getFieldsValue()

    if(!data.tel){
      message.error("请输入正确的手机号!")
      return
    }
    const timer = setInterval(() => {
      setCount(old => {
        if (old === 1) {
          setLiked(true)
          clearInterval(timer)
          return 60
        } else {
          return old - 1
        }
      })
      setLiked(false)
    }, 1000);
    let res = await getRequest("/api/note/getCode", data)
    if (res.code === 200) {
      success("获取验证码成功")
    }
  }


  return (
    <div className='login-form'>
      {contextHolder}
      <div style={{"textAlign":"center", 'marginBottom': "10px"}}>
      <Image preview={false} width={"50px"} src={"https://icon-library.com/images/react-icon/react-icon-28.jpg"}></Image>
      <p className='name'>钧达通讯后台管理系统</p>
      </div>
      <Form
        name="normal_login"
        form={form}
      >
        <Form.Item
          name="tel"
          rules={[{ required: true, message: '请输入手机号!' }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="手机号" />
        </Form.Item>
        <div className='code-box'>
          <Form.Item
            name="code"
          // rules={[{ required: true, message: '请输入验证码!' }]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="验证码"
            />
          </Form.Item>
          {
            liked ? (<div className='get-code' onClick={getCode}>获取验证码</div>) : (<div className='get-code'>{count}秒</div>)
          }
        </div>

        <Form.Item {...buttonLayout}>
          <Button type="primary" htmlType="submit" onClick={submitData}>
            提交
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default App;